import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import AuthForm from './components/Auth/AuthForm'
import EMDRApp from './components/EMDR/EMDRApp'
import LoadingSpinner from './components/UI/LoadingSpinner'
import SuccessMonthly from './components/Payment/SuccessMonthly'
import SuccessYearly from './components/Payment/SuccessYearly'
import CancelPage from './components/Payment/CancelPage'
import LandingPage from './components/Landing/LandingPage'
import './App.css'

const AppContent = () => {
  try {
    const { user, loading } = useAuth()

    console.log('AppContent render:', { user, loading })

    if (loading) {
      return <LoadingSpinner />
    }

    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<EMDRApp />} />
        <Route path="/login" element={<AuthForm />} />
        <Route path="/success-monthly" element={<SuccessMonthly />} />
        <Route path="/success-yearly" element={<SuccessYearly />} />
        <Route path="/cancel" element={<CancelPage />} />
      </Routes>
    )
  } catch (error) {
    console.error('Erreur dans AppContent:', error)
    return (
      <div style={{ padding: '20px', color: 'white', textAlign: 'center' }}>
        <h2>Erreur de l'application</h2>
        <p>Une erreur s'est produite : {error.message}</p>
        <p>Vérifiez la console pour plus de détails.</p>
      </div>
    )
  }
}

function App() {
  try {
    console.log('App component render')
    return (
      <Router>
        <AuthProvider>
          <div className="App">
            <AppContent />
          </div>
        </AuthProvider>
      </Router>
    )
  } catch (error) {
    console.error('Erreur dans App:', error)
    return (
      <div style={{ padding: '20px', color: 'white', textAlign: 'center', background: '#f44336' }}>
        <h1>Erreur critique</h1>
        <p>L'application n'a pas pu démarrer : {error.message}</p>
        <p>Vérifiez votre configuration et la console pour plus de détails.</p>
      </div>
    )
  }
}

export default App 